function shareContent() {
  if (navigator.share) {
    navigator.share({
      title: 'Check this out!',
      text: 'Look at this cool content.',
      url: window.location.href
    })
  } else {
    alert('Sharing not supported on this browser. Please copy the link manually.');
  }
}

window.openSizeModal = function() {
  const modal = document.getElementById("mecnexSizeModal");
  if(modal) {
    modal.style.display = "block";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        modal.classList.add("show");
      });
    });
    document.body.style.overflow = "hidden"; 
  } else {
    console.error("Modal ID 'mecnexSizeModal' nahi mila!"); 
  }
}

window.closeSizeModal = function() {
  const modal = document.getElementById("mecnexSizeModal");
  if(modal) {
    modal.classList.remove("show");
    setTimeout(() => {
      modal.style.display = "none";
    }, 400); 
    document.body.style.overflow = "auto"; 
  }
}

;(() => {
  const emailHref = "mailto:contact@mecnex.com";
  const instagramHref = "https://www.instagram.com/mecnex/";

  const makeLink = (text, href) => {
    const link = document.createElement("a");
    link.href = href;
    link.target = "_blank";
    link.rel = "noopener";
    link.textContent = text;
    return link;
  };

  const linkTextReferences = (root) => {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue.match(/(@mecnex|contact@mecnex\.com)/i)) {
          return NodeFilter.FILTER_REJECT;
        }

        if (node.parentElement?.closest("a, script, style")) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const fragment = document.createDocumentFragment();
      const parts = node.nodeValue.split(/(@mecnex|contact@mecnex\.com)/ig);

      parts.forEach((part) => {
        if (!part) return;

        if (part.toLowerCase() === "@mecnex") {
          fragment.appendChild(makeLink(part, instagramHref));
        } else if (part.toLowerCase() === "contact@mecnex.com") {
          fragment.appendChild(makeLink(part, emailHref));
        } else {
          fragment.appendChild(document.createTextNode(part));
        }
      });

      node.parentNode.replaceChild(fragment, node);
    });
  };

  const enhancePolicyLinks = () => {
    if (!document.body.classList.contains("mecnex-contact-policy-page") && !document.body.classList.contains("mecnex-cancellation-page")) {
      return;
    }

    const root = document.body.classList.contains("mecnex-contact-policy-page")
      ? document.querySelector(".shopify-policy__body")
      : document.querySelector(".page-width .rte");

    linkTextReferences(root);
  };

  window.mecnexLinkContactReferences = linkTextReferences;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhancePolicyLinks);
  } else {
    enhancePolicyLinks();
  }
})();

;(() => {
  const enhancePolicyContent = () => {
    if (!document.body.classList.contains("mecnex-policy-page")) return;

    const content = document.querySelector(".shopify-policy__body .rte");
    const title = document.querySelector(".shopify-policy__title h1");
    if (!content || !title || content.dataset.mecnexEnhanced === "true") return;

    const normalize = (value) => (value || "")
      .replace(/\*\*/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    const firstContentBlock = Array.from(content.children)
      .find((element) => normalize(element.textContent));

    if (firstContentBlock && normalize(firstContentBlock.textContent) === normalize(title.textContent)) {
      firstContentBlock.remove();
    }

    const textNodes = [];
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.includes("**")) textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      const parts = node.nodeValue.split(/(\*\*[^*]+\*\*)/g);
      const fragment = document.createDocumentFragment();

      parts.forEach((part) => {
        if (!part) return;
        if (part.startsWith("**") && part.endsWith("**")) {
          const strong = document.createElement("strong");
          strong.textContent = part.slice(2, -2);
          fragment.appendChild(strong);
        } else {
          fragment.appendChild(document.createTextNode(part));
        }
      });

      node.parentNode.replaceChild(fragment, node);
    });

    Array.from(content.children).forEach((element) => {
      const text = element.textContent.replace(/\u00a0/g, " ").trim();

      if (!text || text === "---") {
        element.remove();
        return;
      }

      const label = element.querySelector(":scope > strong:first-child");
      if (!label) return;

      element.classList.add("mecnex-policy-point");
      Array.from(element.childNodes).forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          child.nodeValue = child.nodeValue.replace(/^\s*-\s*/, "");
        }
      });
    });

    content.dataset.mecnexEnhanced = "true";
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhancePolicyContent);
  } else {
    enhancePolicyContent();
  }
})();

;(() => {
  const formatMoney = (cents, referenceText = "") => {
    const amount = Number(cents) / 100;
    const formatted = amount.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return referenceText.includes("Rs.") ? `Rs. ${formatted}` : formatted;
  };

  const hydrateComparePrices = async () => {
    const blocks = Array.from(document.querySelectorAll(".mn-product-price-block[data-product-json-url]"))
      .filter((block) => !block.querySelector(".mn-price-compare"));

    if (!blocks.length) return;

    const productCache = new Map();

    await Promise.all(blocks.map(async (block) => {
      const url = block.dataset.productJsonUrl;
      const currentPrice = Number(block.dataset.productCurrentPrice);
      const regularPrice = block.querySelector(".mn-price-regular");

      if (!url || !currentPrice || !regularPrice) return;

      try {
        if (!productCache.has(url)) {
          productCache.set(url, fetch(url).then((response) => response.ok ? response.json() : null));
        }

        const product = await productCache.get(url);
        const comparePrice = Number(product?.compare_at_price);

        if (!comparePrice || comparePrice <= currentPrice) return;

        const compare = document.createElement("span");
        compare.className = "mn-price-compare";
        compare.textContent = formatMoney(comparePrice, regularPrice.textContent);

        const discount = document.createElement("span");
        discount.className = "mn-price-discount";
        discount.textContent = `${Math.round(((comparePrice - currentPrice) * 100) / comparePrice)}% OFF`;

        regularPrice.insertAdjacentElement("afterend", compare);
        compare.insertAdjacentElement("afterend", discount);
      } catch (error) {
        console.warn("Unable to load compare price", error);
      }
    }));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hydrateComparePrices);
  } else {
    hydrateComparePrices();
  }
})();

;(() => {
  const enhanceContactPolicy = () => {
    if (!document.body.classList.contains("mecnex-contact-policy-page")) return;

    const body = document.querySelector(".shopify-policy__body");
    const source = body?.querySelector(".rte");
    if (!body || !source || body.classList.contains("is-enhanced")) return;

    const page = document.createElement("div");
    page.className = "mecnex-contact-page";
    page.innerHTML = `
      <p class="mecnex-contact-page__intro">We would love to hear from you. Whether you have a question, feedback, or need help with an order, our team is here during working hours.</p>

      <div class="mecnex-contact-page__grid">
        <section class="mecnex-contact-card">
          <h2 class="mecnex-contact-card__label">WhatsApp</h2>
          <p class="mecnex-contact-card__value">9217277362</p>
          <p class="mecnex-contact-card__note">Please drop your query here. Our team will get back to you shortly during working hours.</p>
          <p class="mecnex-contact-card__note">Monday - Saturday<br>11:00 AM - 6:00 PM</p>
        </section>

        <section class="mecnex-contact-card">
          <h2 class="mecnex-contact-card__label">Email</h2>
          <p class="mecnex-contact-card__value"><a href="mailto:contact@mecnex.com" target="_blank" rel="noopener">contact@mecnex.com</a></p>
          <p class="mecnex-contact-card__note">For support or general inquiries, email us anytime. We typically respond within 1-2 business days.</p>
        </section>

        <section class="mecnex-contact-card">
          <h2 class="mecnex-contact-card__label">Visit Us</h2>
          <p class="mecnex-contact-card__value">Capital plaza,Thokar No.6,Shaheen Bagh, Okhla, New Delhi - 110025</p>
          <p class="mecnex-contact-card__note">Please schedule an appointment in advance to ensure availability.</p>
        </section>
      </div>

      <section class="mecnex-contact-page__legal">
        <h2>Business Details</h2>
        <dl class="mecnex-contact-page__legal-list">
          <div>
            <dt>Legal Name</dt>
            <dd>MECNEX CLOTHING PVT LTD</dd>
          </div>
          <div>
            <dt>Trade Name</dt>
            <dd>MECNEX CLOTHING PVT LTD</dd>
          </div>
          <div>
            <dt>GST No.</dt>
            <dd>07AATCM5129J1ZY</dd>
          </div>
          <div>
            <dt>Registered Address</dt>
            <dd>E-137/3, Shaheen Bagh, Abul Fazal Enclave Part-2, New Delhi - 110025</dd>
          </div>
        </dl>
      </section>

      <section class="mecnex-contact-page__closing">
        <h2>Follow Us</h2>
        <p>Stay connected on Facebook, LinkedIn, and <a href="https://www.instagram.com/mecnex/" target="_blank" rel="noopener">Instagram</a> for updates, news, and promotions. Thank you for reaching out to us.</p>
      </section>
    `;

    body.appendChild(page);
    window.mecnexLinkContactReferences?.(page);
    body.classList.add("is-enhanced");
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceContactPolicy);
  } else {
    enhanceContactPolicy();
  }
})();
